import {ChangeDetectionStrategy, Component, EventEmitter, OnInit} from "@angular/core";
import {AbstractNDropdownMenuItemComponent, IDropdownMenuItem} from "./n-dropdown-menu.component";
import {of} from "rxjs";


@Component({
  selector: "n-dropdown-menu-divider",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ``,
  providers: [{ provide: AbstractNDropdownMenuItemComponent, useExisting: NDropdownMenuDividerComponent }],
})
export class NDropdownMenuDividerComponent implements OnInit {
  private menuItem: IDropdownMenuItem;

  ngOnInit(): void {
    this.menuItem = {
      id: this,
      divider: true,
      heading: of(""),
      disabled: of(true),
      iconId: of(""),
      iconColor: of(""),
      iconSize: of(14),
      url: of(""),
      select: new EventEmitter<any>(false),
      disabledSnapshot: () => true,
      headingSnapshot: () => ""
    };
  }

  getDropdownMenuItem(): IDropdownMenuItem {
    return this.menuItem;
  }
}
